import DOMPurify from "dompurify";

const PADRAO_TAG = /<\/?[a-z][\s\S]*>/i;

const OPCOES_SANITIZACAO = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["style", "form", "input", "button", "iframe"],
  FORBID_ATTR: ["style"],
};

// Links da resposta abrem em nova aba sem dar acesso à janela do ERP.
DOMPurify.addHook("afterSanitizeAttributes", (no) => {
  if (no.tagName === "A") {
    no.setAttribute("target", "_blank");
    no.setAttribute("rel", "noopener noreferrer");
  }
});

export const contemHtml = (texto) => typeof texto === "string" && PADRAO_TAG.test(texto);

export const sanitizarHtml = (texto) => DOMPurify.sanitize(texto ?? "", OPCOES_SANITIZACAO);
